const APP_VERSION = "2026-08-19 12:32";
export default APP_VERSION;
